import { GetAllAssetInsightsReq } from "@/api/studio/insights/api";

/*
 * getTopScore function
 *
 * This function determines if the current index is the top score based on the sorting order.
 */
export const getTopScore = (index: number, insightsLength: number, sortBy: GetAllAssetInsightsReq["sortBy"]) => {
  if (sortBy === "desc") {
    return index === 0;
  } else if (sortBy === "asc") {
    return index === insightsLength - 1;
  }
  return false;
};
